import { Accordion } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import './faq.css'; // Adjust path if needed


const FAQ = () => {

    const faq = [
        { question: 'What types of solar panels does Gautam Solar manufacture?', answer: 'Gautam Solar specializes in advanced mono PERC and TOPCon solar panels, delivering high-efficiency photovoltaic modules for utility-scale and industrial applications. Our solar panel manufacturing lines integrate cutting-edge cell technologies to maximize energy yield and reliability.' },
        { question: 'What is TOPCon and Mono PERC technology?', answer: 'Tunnel Oxide Passivated Contact (TOPCon) is a next-generation solar cell architecture that enhances electron passivation for superior efficiency, commonly exceeding 23 % cell conversion rates. Mono PERC (Passivated Emitter and Rear Cell) employs a rear-side passivation layer to reduce electron recombination, boosting module performance in both residential and commercial solar panel manufacturing.' },
        { question: 'What is the efficiency of Gautam Solar’s solar cells?', answer: 'Our TOPCon solar technology modules routinely achieve efficiencies above 22 %, outperforming standard multicrystalline panels and ensuring optimal return on investment for large-scale solar EPC projects. By leveraging mono PERC advancements, we deliver market-leading performance across varied climate conditions.' },
        { question: 'Where are Gautam Solar’s manufacturing facilities located?', answer: 'Gautam Solar operates state-of-the-art factories in Haridwar and Bhiwani, Haryana, with plans to expand capacity by 5 GWp by the end of 2025. Our EPC-aligned infrastructure supports turnkey solar panel manufacturing and solar project execution for EPC clients nationwide.' },
        { question: 'How does Gautam Solar ensure quality and detect panel defects?', answer: 'Gautam Solar employs AI-driven defect detection systems during production to identify micro-cracks, soldering faults, and material inconsistencies in real time. Post-manufacturing, each panel undergoes electroluminescence and thermal imaging inspections to uphold our strict solar panel manufacturing quality standards.' },
        { question: 'How do I maintain Gautam Solar panels for optimal performance?', answer: 'Our solar panel maintenance recommendations include periodic cleaning to remove dust, debris, and pollens, plus annual electrical inspections to verify wiring integrity and inverter performance. Implementing remote monitoring systems enables real-time performance analytics and proactive issue detection for large-scale solar EPC installations.' },
        { question: 'What is the expected degradation rate of Gautam Solar panels and how does it impact long-term performance?', answer: 'Gautam Solar’s mono PERC and TOPCon modules exhibit an industry-leading median degradation rate of approximately 1% for the first year and then 0.4% per year, ensuring over 90 % of rated power output even after 20 years of operation. This low annual decline translates to 80–90 % power retention at the end of a 25-year service life, minimizing energy yield loss for large-scale and utility-scale solar EPC projects' }
    ]

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": 'FAQPage',
        "mainEntity": faq.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer
            }
        }))
    };

    return (
        <div className="container py-5">
            <div className='border rounded' style={{background:'#E5E7EB'}}>
                <Helmet>
                    <script type='application/ld+json'>
                        {JSON.stringify(faqSchema)}
                    </script>
                </Helmet>

                <h2 className="fw-semibold text-center textRes" style={{ color: '#a20000' }}> <span className='text-black'>FREQUENTLY</span> ASKED QUESTIONS</h2>
                <div className="container py-5 d-flex flex-column flex-md-row">

                    <div className="col-md-12"  >
                        <Accordion  >
                            {faq.map((item, index) => (
                                <Accordion.Item eventKey={index} key={index} className="custom-accordion-item">
                                    <Accordion.Header >{index + 1}. {item.question}</Accordion.Header>
                                    <Accordion.Body >
                                        {item.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
